import React, { useRef } from 'react'
import Skeleton from 'react-loading-skeleton'

const Index = () => {
    const refs = useRef()
    return (
        <div className="membership-package-ghost">
            <div className="container-fluid">
                <div className="row">

                    {[...Array(8).keys()].map((i) => {
                        return (
                            <div className="col-12 col-sm-6 col-xl-4 col-xxl-3 col-padding mb-2" key={i}>
                                {/* Package card */}
                                <div className="card border-0 package-card" style={styles.card}>
                                    <div className="card-body py-4" ref={refs}>
                                        <div className="text-center">
                                            <Skeleton width={70} height={70} circle={true} className="m-auto" />
                                            <br />
                                            <br />

                                            <Skeleton width={150} height={30} />
                                            <div className="mb-3">
                                                <Skeleton width={100} height={25} />
                                                <br />
                                                <Skeleton width={150} height={15} />
                                            </div>
                                        </div>

                                        <Skeleton width={refs.innerWidth} height={15} count={5} />
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </div>
            </div>
        </div>
    );
}

export default Index;

const styles = {
    card: {
        borderRadius: 6,
        Overflow: 'hidden'
    }
}